import React, { useState } from "react";
import "../css/Header.css";
import ic_hamburger_menu from "../img/ic_menu_header.png";
import cwheels_header_icon from "../img/cwheels_header_icon.jpg";
import SideDrawer from "./SideDrawer";

function Header() {

    const [showHideSideDrawerState, setShowHideSideDrawerState] = useState(false);
    const showHideSideDrawer = ()=>{
        setShowHideSideDrawerState(prev => !prev)
    }

    return (
        <div className="Header-root-container">

            <div className="Header-content-container">

                
                <img className="Header-logo-icon" src={cwheels_header_icon}/>

                <div className="Header-options-container">
                    <img onClick={()=>showHideSideDrawer()} src={ic_hamburger_menu} className="Header_menu_image" />
                </div>

            </div>

            {
                showHideSideDrawerState && <SideDrawer showHideSideDrawer={showHideSideDrawer}/>
            }

        </div>
    )
}

export default Header;